const makePayments = {
  requires_2fa_on_new_session: `Two-factor authentication is required to reconnect this account.`,
  requires2fa_newsession: `Two-factor authentication is required to reconnect this account.`,
  wealthreader_reconnect_widget_title: `Complete two-factor authentication`,
  select_payment_gateway: "Select payment gateway",
  connect_payment_gateway: `Connect payment gateway`,
  manual_payment_via_csv: "Manual payment (CSV)",
  manual_payment_via_csv_description:
    "Download a pre-filled CSV template based on the selected documents, enter the payment details, and upload the file to process the payment.",
  sepa_template: `SEPA template`,
  sepa_template_description: `Enter account holder name and IBAN to generate a SEPA-compliant template file for European bank transfers.`,
  payment_gateway: `Payment gateway`,
  payment_gateway_description: `Process payments instantly through your linked bank accounts. Select from available payment gateways.`,
  please_select_payment_gateway: `Please select payment gateway`,
  connect_bank: `Connect bank`,
  please_select_bank: `Please select your bank`,
  payment_template: `Payment template`,
  payment_template_description: `Generate bank payment templates in supported formats to process payments through your bank.`,
  sepa_template_card_description: `Standard format for Single Euro Payments Area transfers (PAIN.001)`,
  please_select_payment_template: `Please select payment template`,
  supplier_accountholdername_notfound: `Supplier account holder name not found`,
  select_payment_method: `Choose how you want to process the payment by selecting one of the available payment methods below.`,
  template_type: `Template type`,
  payment_template_is_required: `Payment template is required`,
  debitor_account_holder_required: `Debitor account holder is required`,
  debitor_iban_required: `Debitor IBAN is reuquired`,
  supplier_currency_notfound: `Supplier currency not found`,
  payment_template_generated_successfully: `Payment template generated successfully`,
  document_ids_required: `Document IDs required`,
  debitor_accountholdername_required: `Debitor account holder name required`,
  duedate_required: `Due date required`,
  supplier_not_created: `Supplier not created`,
  supplier_iban_notfound: `Supplier IBAN not found`,
  "selected_document(s)_status_shouldbe_processedorreviewed": `Selected document(s) status should be processed or reviewed`,
  "selected_document(s)_doctype_shoudbe_invoice": `Selected document(s) doctype should be invoice`,
  "selected_document(s)_shouldbe_approved": `Selected document(s) should be approved`,
  "selected_document(s)_shouldnotbe_sepaexported": `Selected document(s) should not be sepa exported`,
  "selected_document(s)_acountclass_shoudbe_accountpayable": `Selected document(s) account class should be account payable`,
  "selected_document(s)_paymentstatus_shoudbe_unpaidordue": `Selected document(s) payment status should be unpaid or due`,
  "selected_document(s)_vendorcompanyid_shoudnotbe_empty": `Selected document(s) vendor company id should not be empty`,
  "selected_document(s)_shoudbe_same_supplier_vendor": `Selected document(s) supplier/vendor should be same`,
  "selected_document(s)_shoudbe_same_supplier/vendor": `Selected document(s) supplier/vendor should be same`,
  select_account: `Select bank account`,
  gateway_not_connected: `Payment gateway not connected. Please connect your bank account to proceed with payments.`,
  bank_not_selected: `Bank is not selected, please select bank to sync transactions`,
  fetching_bankdetail: `Fetching bank details. This may take some time.`,
  "selected_document(s)_shoudhave_customercompanyname": `Selected document(s) should have customer company name`,
  "selected_document(s)_shoudbe_same_customercompanyid": `Selected document(s) should have same customer company Id`,
  "selected_document(s)_customercompanyid_shoudnotbe_empty": `Selected document(s) customer company Id should not be empty`,
  supplier_document_expired: `Supplier document is expired`,
  consider_individual_transaction: `Consider individual transaction`,
  bank_already_connected: `Bank already connected`,
  ag: `A&G`,
  payment_not_supported: `Payment not supported`,
  wealthreader_relogin: `Our bank login details have changed, so the connection is no longer valid. Please disconnect and reconnect your bank account with the updated credentials to resume transaction syncing.`,
  sync_history: `Sync history`,
  view_sync_history: `View sync history`,
  syncStartedOn: `Sync started on`,
  syncCompletedOn: `Sync completed on`,
  dateFrom: `Date from`,
  error_message: `Error message`,
  error_category: `Error category`,
  WealthreaderTransactionSyncJob: `Wealth reader transaction sync`,
  RequiresLiveAction: `Requires live action`,
  reconnect_your_bank_account: `Reauthenticate your {{bankName}} bank account`,
  enter_your_credentials_to_receive_an_otp: `Enter your credentials. You'll receive an OTP to complete the authentication.`,
};

export default makePayments;
